import * as React from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import useNumberFormatter from '@/hooks/useNumberFormatter'
import { cn } from '@/lib/utils'
import type { MobileTable } from './useMobileTable'

/**
 * Vault checklist that scopes the vault rows and the closing balance.
 * Category and net figures stay team-wide, same as the desktop grid.
 */
export default function VaultScopeList({
  table,
  compact = false,
}: {
  table: MobileTable
  compact?: boolean
}) {
  const formatter = useNumberFormatter({})
  const period = table.periodByOffset.get(table.offsets[0])

  return (
    <div className="flex flex-col">
      {table.scope.vaults.map((v) => {
        const on = table.scope.isSelected(v.id)
        const balance = period?.vaults?.[v.id]?.closing_balance ?? 0
        return (
          <button
            type="button"
            key={v.id}
            role="checkbox"
            aria-checked={on}
            onClick={() => table.scope.toggle(v.id)}
            className={cn(
              'flex items-center gap-2.5 border-b border-light text-left',
              compact ? 'py-2.5' : 'py-3',
              v.groupName && 'pl-3.5',
            )}
          >
            <span className="pointer-events-none flex shrink-0">
              <Checkbox checked={on} tabIndex={-1} />
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-px">
              <span
                className={cn(
                  'truncate font-semibold text-txt-primary',
                  compact ? 'text-[13px]' : 'text-[14.5px]',
                )}
              >
                {v.name}
              </span>
              {!compact && (v.description || v.groupName) && (
                <span className="truncate text-[11.5px] text-txt-placeholder">
                  {[v.description, v.groupName && `in ${v.groupName}`]
                    .filter(Boolean)
                    .join(' · ')}
                </span>
              )}
            </span>
            <span
              className={cn(
                'shrink-0 font-semibold tabular-nums text-txt-secondary',
                compact ? 'text-xs' : 'text-sm',
              )}
            >
              {formatter(balance)}
            </span>
          </button>
        )
      })}
    </div>
  )
}
